<template>
	<nav>
		<ul class="d-flex gap-2">
			<li><a href="/product" :class="[location.includes('product') ? 'router-link-active router-link-exact-active' : '']">Product</a></li>
      <li><a href="/features" :class="[location.includes('features') ? 'router-link-active router-link-exact-active' : '']">Features</a></li>
			<li>
				<a href="/" @click.prevent :class="[location.includes('solutions') ? 'router-link-active router-link-exact-active' : '']">
          Solutions <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m5 7.5 5 5 5-5" stroke="#000" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" /></svg>
        </a>
				<ul>
					<li :class="{ active: location.includes('club') }">
						<a href="/solutions-clubs">
							<svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path
									d="M11.25 5.417h5.171c.358 0 .536 0 .644.075a.417.417 0 0 1 .173.28c.02.13-.06.29-.22.61l-1.044 2.087a.903.903 0 0 0-.088.21.417.417 0 0 0-.004.145c.009.055.032.108.08.214l1.121 2.525c.14.312.209.468.186.595a.417.417 0 0 1-.176.27c-.106.072-.277.072-.619.072h-6.39c-.467 0-.7 0-.879-.09a.833.833 0 0 1-.364-.365c-.091-.178-.091-.412-.091-.878v-2M2.5 17.5V2.917m0 6.25h7.417c.466 0 .7 0 .878-.091a.833.833 0 0 0 .364-.364c.091-.178.091-.412.091-.878V3.417c0-.467 0-.7-.09-.878a.833.833 0 0 0-.365-.365c-.178-.09-.412-.09-.878-.09H3.833c-.466 0-.7 0-.878.09a.833.833 0 0 0-.364.365c-.091.178-.091.411-.091.878v5.75z"
									stroke="#FA1F63"
									stroke-width="1.6"
									stroke-linecap="round"
									stroke-linejoin="round"
								/>
							</svg>
							<span>Club <small>Fuel Your Club's Success</small></span>
						</a>
					</li>
					<li :class="{ active: location.includes('leagues') }">
						<a href="/solutions-leagues">
							<svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="m7.397 10.913-3.48-4.35c-.216-.27-.325-.405-.402-.556a1.667 1.667 0 0 1-.148-.423c-.034-.166-.034-.34-.034-.686v-.565c0-.933 0-1.4.182-1.756.16-.314.414-.569.728-.729.357-.181.823-.181 1.757-.181h8c.933 0 1.4 0 1.756.181.314.16.569.415.729.729.181.356.181.823.181 1.756v.565c0 .346 0 .52-.034.686-.03.147-.08.29-.148.423-.077.15-.185.286-.402.557l-3.48 4.349M4.167 2.5 10 10l5.833-7.5m-2.887 8.72a4.167 4.167 0 1 1-5.893 5.893 4.167 4.167 0 0 1 5.893-5.893z" stroke="#FA1F63" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
							</svg>
							<span>League <small>Ignite Your League’s Spirit</small></span>
						</a>
					</li>
					<li :class="{ active: location.includes('federations') }">
						<a href="/solutions-federations">
							<svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M15 13.197c1.214.61 2.254 1.588 3.013 2.811.15.242.226.363.252.531.052.34-.18.76-.498.895-.156.066-.332.066-.683.066m-3.75-7.89a3.75 3.75 0 0 0 0-6.72m-1.667 3.36a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0zm-9.534 9.532C3.462 13.787 5.558 12.5 7.917 12.5s4.455 1.287 5.784 3.282c.291.437.437.655.42.935a.924.924 0 0 1-.33.614c-.222.169-.53.169-1.143.169H3.186c-.614 0-.92 0-1.144-.169a.924.924 0 0 1-.329-.614c-.017-.28.129-.498.42-.935z" stroke="#FA1F63" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
							</svg>
							<span>Federation <small>Empower Your Federation Seamlessly</small></span>
						</a>
					</li>
					<li :class="{ active: location.includes('tournaments') }">
						<a href="/solutions-tournaments">
							<svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg">
								<g clip-path="url(#a)">
									<path
										d="M10 12.5a5 5 0 0 1-5-5V2.87c0-.345 0-.517.05-.655a.833.833 0 0 1 .499-.498c.138-.05.31-.05.655-.05h7.593c.345 0 .517 0 .655.05a.833.833 0 0 1 .498.498c.05.138.05.31.05.655V7.5a5 5 0 0 1-5 5zm0 0V15m5-11.667h2.084c.388 0 .582 0 .735.064a.833.833 0 0 1 .451.45c.064.154.064.348.064.736V5c0 .775 0 1.162-.085 1.48a2.5 2.5 0 0 1-1.768 1.768c-.318.085-.706.085-1.48.085m-10-5H2.916c-.388 0-.582 0-.736.064a.833.833 0 0 0-.45.45c-.064.154-.064.348-.064.736V5c0 .775 0 1.162.085 1.48A2.5 2.5 0 0 0 3.52 8.248c.318.085.705.085 1.48.085m1.204 10h7.593a.37.37 0 0 0 .37-.37A2.963 2.963 0 0 0 11.204 15H8.797a2.963 2.963 0 0 0-2.963 2.963c0 .204.165.37.37.37z"
										stroke="#FA1F63"
										stroke-width="1.6"
										stroke-linecap="round"
										stroke-linejoin="round"
									/>
								</g>
								<defs>
									<clipPath id="a"><path fill="#fff" d="M0 0h20v20H0z" /></clipPath>
								</defs>
							</svg>
							<span>Tournament <small>Spark Your Event Excitement</small></span>
						</a>
					</li>
				</ul>
			</li>
			<li><a href="/pricing" :class="[location.includes('pricing') ? 'router-link-active router-link-exact-active' : '']">Pricing</a></li>
			<li><a href="/about-us" :class="[location.includes('about-us') ? 'router-link-active router-link-exact-active' : '']">About Us</a></li>
		</ul>
	</nav>
</template>

<script>
export default {
	name: "HeaderNav",
	data() {
		return {
			location: window.location.href,
		};
	},
};
</script>

<style>
  ul {
    font-size: 0.875rem;
  }
</style>